import React, { type JSX } from 'react';
import { TranslationValues } from 'next-intl';
import { IPrismicLink, PrismicLinkContext } from '@monofront/types';
import { PrismicLink } from '../../prismic-link/PrismicLink';

export interface IListBoxLine<T> {
  icon?: React.FC;
  illustration?: JSX.Element;
  text: T;
  prismicLink?: IPrismicLink | null;
  variables?: TranslationValues;
}
export interface IListBox<T> {
  title?: T;
  lines: IListBoxLine<T>[];
}

interface IListBoxProps<T> {
  content: IListBox<T>;
  bgColor?: string;
  context?: PrismicLinkContext;
  openSidePanel?: (uid?: string) => void;
  UNSAFE_className?: string;
}

const ListBox = ({
  content: { title, lines },
  bgColor,
  context = PrismicLinkContext.SHOP,
  openSidePanel,
  UNSAFE_className = '',
}: // @ts-expect-error: Generic type in IOurGuaranteesProps need to be correcly inferred (@intl-ts)
IListBoxProps<T>) => (
  <section
    className={`tw-lf-list-box-container ${UNSAFE_className}`}
    style={bgColor ? { backgroundColor: bgColor } : undefined}
  >
    {title && <h2 className="tw-lf-list-box-title">{title}</h2>}
    <ul className="">
      {lines.map(({ icon, illustration, text, prismicLink }, index) => {
        const Icon = icon;

        const content = (
          <>
            <span className="tw-lf-list-box-line-picto" aria-hidden="true">
              {Icon ? <Icon /> : null}
              {illustration ? illustration : null}
            </span>
            <span className="tw-lf-list-box-line-text">{text}</span>
          </>
        );

        if (prismicLink) {
          return (
            <li
              key={index}
              className="tw-lf-list-box-line [&>a]:tw-lf-link-md [&>a]:tw-lf-link-dark [&>button]:tw-lf-link-md [&>button]:tw-lf-link-dark"
            >
              <PrismicLink
                link={prismicLink}
                context={context}
                openSidePanel={openSidePanel}
                className="tw-lf-list-box-line"
              >
                {content}
              </PrismicLink>
            </li>
          );
        }

        return (
          <li key={index} className="tw-lf-list-box-line">
            {content}
          </li>
        );
      })}
    </ul>
  </section>
);

export default ListBox;
